class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onNotificationAreaClick = this.handleNotificationAreaClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

open() {
  document.documentElement.classList.add('cart-notification-open');
  this.notification.classList.add('animate', 'active');

  this.notification.addEventListener(
    'transitionend',
    () => {
      this.notification.focus();
      trapFocus(this.notification);
    },
    { once: true }
  );

  document.body.addEventListener('click', this.onBodyClick);
  this.notification.addEventListener('click', this.onNotificationAreaClick);
}

  close() {
    document.documentElement.classList.remove('cart-notification-open');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.notification.removeEventListener('click', this.onNotificationAreaClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    this.open();
  }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
      ];
    }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

handleBodyClick(evt) {
  const target = evt.target;

  /* ポップアップ外をクリックしても閉じない */
  if (target !== this.notification && !target.closest('cart-notification')) {
    return;
  }
}

  handleNotificationAreaClick(evt) {
    const target = evt.target;

    /* 中央の商品情報内「買い物を続ける」は、動的描画後でも閉じる */
    if (target.closest('.cb-notif-inline-links .button-label')) {
      evt.preventDefault();
      this.close();
      return;
    }

    /* CTAやリンク、入力系は閉じない */
    if (target.closest('a, button, input, select, textarea, summary, [role="button"]')) return;

    /* ポップアップの中をクリックしたら閉じる */
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
